import React, {PropTypes} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import moment from 'moment';
// LOCAL
import RangePicker from './RangePicker'
import CalendarIcon from './CalendarIcon'
// SHARED
import muiTheme from '../../utils/muiTheme'

  const svgStyleGreen ={
    fill: "#31b59f",
    width: "25px",
    height: "25px"
  }
  const svgStyleWhite ={
    fill: "#ffffff",
    width: "25px",
    height: "25px"
  }

export default class DateRangePopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      byDateOpen: false,
    };
  }

  handleTouchTap = (event) => {
    // This prevents ghost click.
    event.preventDefault();
    this.setState({
      byDateOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      byDateOpen: false,
    });

    this.props.onClose(this.state.selected_dates);
  };

  handleChangeRange(from, to){
    if (!from || !to) return
    // bug with .month() replaced with format('M')
    this.setState({
      "selected_dates": {
        start_day: moment(from).date(),
        start_month: moment(from).format('M'),
        start_year: moment(from).year(),
        end_day: moment(to).date(),
        end_month: moment(to).format('M'),
        end_year: moment(to).year()
      }
    })
  }

  render() {
    var d = this.state.selected_dates
    var chooseDatesButtonTitle = d ?
      `${d.start_month}/${d.start_day}/${d.start_year} - ${d.end_month}/${d.end_day}/${d.end_year}` :
       "This Year"

    return (
      <div>
        <MuiThemeProvider muiTheme={muiTheme}>
          <RaisedButton
            onTouchTap={this.handleTouchTap}
            onClick={this.handleTouchTap}
            label={this.state.byDateOpen ? "DONE": chooseDatesButtonTitle}
            className={this.state.byDateOpen ? "raised-button raised-button-green": "raised-button"}
            icon={<CalendarIcon viewBox='0 0 60 60' style={this.state.byDateOpen ? svgStyleWhite: svgStyleGreen} />}
          />
        </MuiThemeProvider>
        <MuiThemeProvider muiTheme={muiTheme}>
          <Popover
            open={this.state.byDateOpen}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
          >
            <RangePicker onRangeChange={this.handleChangeRange.bind(this)} />
          </Popover>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/components/DateRangePopover.js